import { Action } from '@ngrx/store';
import { ProductTypesResponse } from '@cemex-core/cmx-api/models/business-lines/business-lines-response';
import { ShippingConditionsRequest } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-conditions-request';
import { ILegalEntity } from '@cemex-core/cmx-api/models/legal-entities/legal-entity';
import { ProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';

export const LOAD_INITIAL_STATE = '[BusinessLine] Load initial state';
export const LOAD = '[BusinessLine] Load';
export const LOAD_COMPLETE = '[BusinessLine] Load Complete';
export const LOAD_FAIL = '[BusinessLine] Load Fail';
export const SET = '[BusinessLine] SET BusinessLine';
export const LOAD_REPEAT = '[BusinessLine] Load Repeat BusinessLine';

/* If we have information about business line we can set it directly */
export const SET_DIRECT = '[BusinessLine] SET_DIRECT BusinessLine';
export const RESET = '[BusinessLine] RESET BusinessLine';

export class BusinessLineLoadInitialStateAction implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload = null) {}
}

export class BusinessLineLoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: ILegalEntity) {}
}

export class BusinessLineLoadCompleteAction implements Action {
  readonly type = LOAD_COMPLETE;

  constructor(public payload: ProductTypesResponse) {}
}

export class BusinessLineFailAction implements Action {
  readonly type = LOAD_FAIL;

  constructor(public payload: any) {}
}

export class BusinessLineSetAction implements Action {
  readonly type = SET;

  /**
   * @param {string} payload => productLineCode
   */
  constructor(public payload: ShippingConditionsRequest) {}
}

export class BusinessLineSetDirectAction implements Action {
  readonly type = SET_DIRECT;

  /**
   * @param {string} payload => productLineCode
   */
  constructor(public payload: ProductType) {}
}

export class BusinessLineResetAction implements Action {
  readonly type = RESET;

  constructor(public payload: null = null) {}
}

export class BusinessLineLoadRepeatAction implements Action {
  readonly type = LOAD_REPEAT;

  constructor(public payload: ProductTypesResponse) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type BusinessLinesActions =
  | BusinessLineLoadInitialStateAction
  | BusinessLineLoadAction
  | BusinessLineLoadCompleteAction
  | BusinessLineFailAction
  | BusinessLineSetAction
  | BusinessLineSetDirectAction
  | BusinessLineResetAction
  | BusinessLineLoadRepeatAction;
